import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.payments_api.tip_management;

const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'payments_api',
  group: 'tip_management',
  defaultTtl: '10m',
  hashLargeSegments: true,
  emitMeta: true,
});


export const createTipRecord = async (localId: number, data: any) => {
  const res = await retryWithBackoff(() =>
    api.post(`/CreateTipRecord/${localId}`, { data })
  );
  return res;
};

export const getAllTipRecordsByLocalId = async (
  localId: number,
  startDate?: string,
  endDate?: string
) => {
  const params: any = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;

  const res = await retryWithBackoff(() =>
    api.get(`/GetAllTipRecordsByLocalId/${localId}`, { params })
  );
  return res;
};



export const deleteTipRecord = async (recordId: string, timestamp?: string) => {
  const data: any = {};
  if (timestamp) data.timestamp = timestamp;
  const res = await retryWithBackoff(() =>
    api.delete(`/DeleteTipRecord/${recordId}`, { data })
  );
  return res;
};


export const deleteAllTipRecordsByLocalId = async (localId: number) => {
  const res = await retryWithBackoff(() =>
    api.delete(`/DeleteAllTipRecordsByLocalId/${localId}`)
  );
  return res;
};

export const cancelTipRecord = async (recordId: string, timestamp?: string) => {
  const data: any = {};
  if (timestamp) data.timestamp = timestamp;
  const res = await retryWithBackoff(() =>
    api.post(`/CancelTipRecord/${recordId}`, data)
  );
  return res;
};


export const getTipDistribution = async (localId: number, sessionIds: number[]) => {
  const res = await retryWithBackoff(() =>
    api.post(`/GetTipDistribution/${localId}`, { session_ids: sessionIds })
  );
  return res;
};

